import React from 'react';
import StaffLogin from '../Staff/StaffLogin';
import StaffDashboard from '../Staff/StaffDashboard';
import AdminProtectedRoute from "../ProtectedRoute";
import CommonLayout from '../layouts/CommonLayout';
import TaskManage from '../Staff/TaskManage';

const staffRoutes = [
    { path: "/staff/login", element: <StaffLogin /> },
    { path: "/staff/dashboard", element: <AdminProtectedRoute><CommonLayout ><StaffDashboard /></CommonLayout></AdminProtectedRoute> },
    { path: "/staff/task-management", element: <AdminProtectedRoute><CommonLayout ><TaskManage /></CommonLayout></AdminProtectedRoute> },
    { path: "/staff", element: <StaffLogin /> }, // Default redirect to login
    { path: "/staff/activity", element: <AdminProtectedRoute><CommonLayout ><StaffDashboard /></CommonLayout></AdminProtectedRoute> }, // Activity tracking page
];

export default staffRoutes;
